import { AccommodationStockListCriteria, AccommodationStockTotal } from "../objects/accommodationStockList";
import { DisplayedDate } from "../objects/accommodationStockTable";
import { addDays } from 'date-fns';


export const EMPTY_ACCOMMODATION_STOCK_LIST_CRITERIA: AccommodationStockListCriteria = {
    event_site_date: null,
    client: null
};

export const EMPTY_DISPLAYED_DATE: DisplayedDate = {
    start_date: new Date().toISOString(),
    end_date: addDays(new Date(), 5).toISOString()
};

export const EMPTY_ACCOMMODATION_LIST_TOTAL: AccommodationStockTotal = {
    selling_stocks: { total: 0, days: {} },
    stocks: { total: 0, days: {} }
};